import { BerthResponseDto } from '@planning/app/api'
import _ from 'lodash'
import { computed, makeObservable } from 'mobx'
import { EntityItem } from '../base/EntityItem'
import { IEntity } from '../types'
import { IPierItem } from './PierItem'
import { PierItemStore } from './PierItemStore'

export interface IBerthItem extends IEntity<BerthResponseDto> {
  pier?: IPierItem
}

export class BerthItem extends EntityItem<BerthResponseDto> implements IBerthItem {
  constructor(
    id: number,
    data: BerthResponseDto,
    private pierItemStore: PierItemStore,
  ) {
    super(id, data)
    makeObservable(this, {
      pier: computed,
    })
  }

  get pier() {
    if (!this.data.pierId) return undefined

    return _(this.pierItemStore.elements).get(this.data.pierId)
  }
}
